<template>
  <div class="menu">
    <router-link :to="mainLink" class="menu__title">
      {{ title }}
    </router-link>
    <ul class="menu__lista">
      <li 
        class="menu__lista__item main"
        v-for="item in menuPrincipal"
        :key="item.id">
        <router-link
          :to="item.link" 
          class="menu__lista__item__link">
          <icono
            class="menu__lista__item__link__icon"
            :icon="item.icon" 
            :size="27"
            :style="{color: item.color}"></icono>
            <span class="menu__lista__item__link__text">{{ item.option }}</span>
        </router-link>
      </li>
    </ul>
    <router-link :to="secondaryLink" class="menu__title secondary_title">
      {{ secondaryTitle }}
    </router-link>
    <ul class="menu__lista secondary_list">
      <li 
        class="menu__lista__item"
        v-for="opcion in secondaryOptions"
        :key="opcion.id">
        <router-link 
          v-if="opcion.ruta"
          :to="opcion.link" 
          class="menu__lista__item__link secondary_link">
          <icono
            class="menu__lista__item__link__icon"
            :icon="opcion.icon" 
            :size="25"
            :style="{color: '#424242'}"></icono>
            <span class="menu__lista__item__link__text secondary_text">{{ opcion.option }}</span>
        </router-link>
        <a
          v-else
          :href="opcion.link"
          target="_blank"
          class="menu__lista__item__link secondary_link">
          <icono
            class="menu__lista__item__link__icon"
            :icon="opcion.icon" 
            :size="25"
            :style="{color: '#424242'}"></icono>
            <span class="menu__lista__item__link__text secondary_text">{{ opcion.option }}</span>
        </a>
      </li>
    </ul>
    <base-anuncio-card-texto 
      v-if="dataHome"
      :titulo="dataHome.text2"
      :texto="dataHome.text3"
      :click-method="showerDonaciones"
    />
    <div class="">
      <ds-panel-store />
    </div>
    <donar-ds 
      v-if="showDonaciones"
      :closeFunction="closeDonaciones"
    />
  </div>
</template>

<script>
  import { defineAsyncComponent } from 'vue'
  import BaseAnuncioCardTexto from '@/components/anuncios/base/BaseAnuncioCardTexto.vue'
  import DsPanelStore from '@/components/tienda/DsPanelStore.vue'
  //
  import { mapGetters } from 'vuex'

  export default {
    name: 'VBasePanel',
    computed: {
      ...mapGetters({
        dataHome: 'dataHome',
      })
    },
    props: {
      title: String,
      mainLink: {
        type: Object,
        default: {name: 'home'}
      },
      menuPrincipal: {
        type: Array,
        default: [] // id, link, icon, ruta, icon, color, option
      },
      secondaryLink: {
        type: Object,
        default: {name: 'home'}
      },
      secondaryTitle: String,
      secondaryOptions: {
        default: [], // coleccion objetos tipo: {id,option,icon, link, ruta(bool)}
        type: Array
      },
    },
    components: {
      BaseAnuncioCardTexto,
      DsPanelStore,
      DonarDs: defineAsyncComponent(() => import('@/components/equipods/DonarDs.vue')),
    },
    data() {
      return {
        showDonaciones: false
      }
    },
    methods: {
      showerDonaciones: function () {
        this.showDonaciones = true
      },
      closeDonaciones: function () {
        this.showDonaciones = false
      }
    },
  }
</script>

<style lang="scss" scoped>
  .menu {
    box-shadow: 10px 10px 5px -5px rgba(223,230,233,0.4);
    min-height: 85vh;
    max-height: 100%;
    margin-top: 1em;
    margin-bottom: 10px;
    @include hasta($large) {
      display: none;
    }
    &__title {
      display: block;
      padding: 10px 20px;
      text-decoration: none;
      font-family: $ff-5;
      font-weight: bold;
      color: $color-9;
      font-size: 15px;
      text-align: center;
      border-bottom: 1px solid $color-8;
      text-transform: capitalize;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.secondary_title {
        color: $color-7;
        font-weight: normal;
      }
    }
    &__lista {
      list-style: none;
      &.secondary_list {
        border-top: 1px solid $color-8;
      }
      &__item {
        display: block;
        &.main {
          &:first-child a {
            color: $color-5;
            font-weight: bold;
          }
        }
        &__link {
          display: flex;
          text-decoration: none;
          font-family: $ff-5;
          color: $color-1;
          font-size: 17px;
          padding: 7px 20px;
          @include desde_hasta($large, $extra-large) {
            font-size: 14px;
          }
          &__text {
            margin-left: 10px;
            margin-top: 5px;
            &.secondary_text {
              margin-top: 3px;
            }
          }
          &:hover {
            background: $color-8;
          }
          &.secondary_link {
            font-size: 15px;
            color: $color-7;
            @include desde_hasta($large, $extra-large) {
              font-size: 13px;
            }
          }
        }
      }
    }
  }
</style>